module.exports = __webpack_public_path__ + "img/hend.b3215a71.png";